// markup
import ApplicationDetailsInternal from "./CreditApplicationDetailsCmps/ApplicationDetailsInternal";

const CreditApplicationDetails = (props) => {
  const application = props.item;
  const accountInfo = props.accountInfos[application.BorrowerId];

  const extraContentStyle = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div style={extraContentStyle}>
      <ApplicationDetailsInternal
        application={application}
        accountInfo={accountInfo}
        rejectCreditApplication={props.rejectCreditApplication}
        approveRejectCreditOffers={props.approveRejectCreditOffers}
        approveCreditOffer={props.approveCreditOffer}
        rejectCreditOffer={props.rejectCreditOffer}
      />
    </div>
  );
};

export default CreditApplicationDetails;
